import { FC } from "react";

import { useTranslator } from "@/i18n/useTranslator";

import { ImgSliderFromPaths } from "../components/ImgsSliderFromPaths";
import { DsLoading, DsText } from "../components/ui";
import { useTaskNotesQuery } from "../data/queries/notesQueries";
import { JobServiceTaskBaseType } from "../domain/task";

const DriverTaskNotesComponent: FC<JobServiceTaskBaseType> = ({
  jobId,
  serviceId,
  taskId,
}) => {
  const { t } = useTranslator();

  const { data: taskNotes, isLoading } = useTaskNotesQuery({
    jobId,
    serviceId,
    taskId,
  });

  if (isLoading) {
    return (
      <div className="flex flex-col items-center">
        <DsLoading />
        <DsText className="mt-2" variant="badgeText">
          {t("driver_task_notes_component.loading")}
        </DsText>
      </div>
    );
  }

  return (
    <>
      {taskNotes?.map(note => (
        <div key={note.id} className="mb-4">
          {note.files && note.files.length > 0 && (
            <ImgSliderFromPaths paths={note.files} />
          )}
          <DsText
            variant="dataDisplayTitle"
            className="mt-1 text-black text-justify">
            {note.note}
          </DsText>
        </div>
      ))}
    </>
  );
};

export { DriverTaskNotesComponent };
